import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { API_BASE_URL } from "../../api"; // Adjust the path based on your project structure

const Index = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [totalClients, setTotalClients] = useState(0);
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalwebsite, setTotalwebsite] = useState(0);

  // Function to toggle the sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  // Effect to add/remove the sidebar toggle class
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add("toggle-sidebar");
    } else {
      document.body.classList.remove("toggle-sidebar");
    }
    return () => {
      document.body.classList.remove("toggle-sidebar");
    };
  }, [isSidebarOpen]);

  // Fetch data for total clients and total projects
  useEffect(() => {
    const fetchData = async () => {
      try {
        const clientResponse = await axios.get(`${API_BASE_URL}/api/client`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            user_id: localStorage.getItem("userId"),
          },
        });
        const websiteResponse = await axios.get(`${API_BASE_URL}/api/website`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            user_id: localStorage.getItem("userId"),
          },
        });
        const projectResponse = await axios.get(`${API_BASE_URL}/api/project`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            user_id: localStorage.getItem("userId"),
          },
        });
  
        // Assuming the response contains an array of items
        setTotalClients(clientResponse.data.length || 0); // Replace with the correct array path
        setTotalProjects(projectResponse.data.length || 0); // Replace with the correct array path
        setTotalwebsite(websiteResponse.data.length || 0); // Replace with the correct array path
      } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
      }
    };
  
    fetchData();
  }, []);
  

  return (
    <div>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Dashboard</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="javascript:void(0)">Home</a>
              </li>
            </ol>
          </nav>
        </div>

        <section className="section dashboard">
          <div className="row peichart">
            <div className="col-lg-8">
              <div className="row">
                {/* Total Clients Card */}
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">Total Clients</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-person-lines-fill text-primary"></i>
                        </div>
                        <div className="ps-3">
                          <h6>{totalClients}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Total Projects Card */}
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">Total Projects</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-briefcase text-primary"></i>
                        </div>
                        <div className="ps-3">
                          <h6>{totalProjects}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Total Website Card */}
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">Total Website</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-globe"></i>
                        </div>
                        <div className="ps-3">
                          <h6>{totalwebsite}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
